import { useState, useRef, useEffect } from 'react'

// Styles
import styles from './Accordion.module.sass'

interface AccordionProps {
  children: JSX.Element[]
  active?: boolean
  customClass?: string
  maxHeight?: number
  onToggle?: Function
  reverse?: boolean
}
const Accordion = ({
  children,
  active = false,
  customClass,
  maxHeight = 0,
  onToggle,
  reverse = false
}: AccordionProps) => {
  const [accordionState, setAccordionState] = useState(active)
  const [height, setHeight] = useState(0)

  const accordionRef = useRef(null)

  useEffect(() => {
    if (accordionState) {
      if (accordionRef.current) {
        setHeight(accordionRef.current['scrollHeight'])
      }
    } else {
      setHeight(maxHeight)
    }
  }, [accordionState, maxHeight])

  const toggleAccordion = (state: boolean) => {
    setAccordionState(state)
    onToggle && onToggle(state)
  }

  return (
    <div className={`${styles.accordion} ${customClass || ''}`}>
      {reverse ? (
        <>
          <div
            className={styles.accordion__content}
            ref={accordionRef}
            style={{ height }}
          >
            {children[1]}
          </div>

          <div
            className={styles.accordion__button}
            onClick={() => toggleAccordion(!accordionState)}
          >
            {children[0]}
          </div>
        </>
      ) : (
        <>
          <div
            className={styles.accordion__button}
            onClick={() => toggleAccordion(!accordionState)}
          >
            {children[0]}
          </div>

          <div
            className={styles.accordion__content}
            ref={accordionRef}
            style={{ height }}
          >
            {children[1]}
          </div>
        </>
      )}
    </div>
  )
}

interface AccordionContentProps {
  children: JSX.Element
}
const AccordionContent = ({ children }: AccordionContentProps) => (
  <div>{children}</div>
)

interface AccordionButtonProps {
  children: JSX.Element
}
const AccordionButton = ({ children }: AccordionButtonProps) => (
  <div>{children}</div>
)

export { Accordion, AccordionContent, AccordionButton }
